import { createTokenHeader } from '../utils/functions/headers';
import {
  TDemandPlanning,
  TGetDemandPlanningListParams,
  TImportDiscountResponse,
} from '../utils/types';
import { emptySplitApi } from './emptySplitApi';

export const demandPlanningService = emptySplitApi
  .enhanceEndpoints({ addTagTypes: ['list'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getDemandPlanningList: builder.query<
        { data: TDemandPlanning[]; totalCount: number },
        TGetDemandPlanningListParams
      >({
        query: (params) => ({
          url: 'replenishmentInventory/list',
          method: 'GET',
          params: params,
        }),
        transformResponse: (
          data: TDemandPlanning[],
          meta: Response
        ) => {
          const totalCount =
            meta.headers.get('X-total-count');
          return {
            data,
            totalCount: Number(totalCount ? totalCount : 0),
          };
        },
        providesTags: ['list'],
      }),
      demandPlanningExport: builder.query<
        { url?: string },
        { depots: string[] }
      >({
        query: (data) => ({
          url: 'replenishmentInventory/export',
          method: 'POST',
          data,
        }),
      }),
      demandPlanningImport: builder.mutation<
        TImportDiscountResponse,
        FormData
      >({
        query: (data) => {
          return {
            url: 'replenishmentInventory/import',
            method: 'POST',
            data,
            headers: createTokenHeader(),
          };
        },
      }),
    }),
  });

export const {
  useGetDemandPlanningListQuery,
  useLazyDemandPlanningExportQuery,
  useDemandPlanningImportMutation,
} = demandPlanningService;
